/* eslint-disable
    import/no-unresolved,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./clientDetails.scss');
require('angular-scroll');
require('angular-messages');

const deps = [
  'duScroll', // angular-scroll
  'ngMessages',
  require('data/model/client').name,
  require('data/model/address').name,
  require('data/model/clientinfo').name,
  require('data/model/clientSettings').name,
  require('data/model/featureMeta').name,
  require('data/collection/bookkeeper').name,
  require('data/collection/ledger').name,
  require('data/collection/region').name,
  require('data/collection/currency').name,
  require('data/collection/country').name,
  require('data/collection/manager').name,
  require('data/collection/salesPerson').name,
  require('data/collection/taxAccountant').name,
  require('data/collection/billingPartner').name,
  require('data/user').name,
  require('ui/web/confirmDialog').name,
  require('ui/web/conversations').name,
  require('ui/web/conversationList').name,
  require('ui/web/form/select').name,
  require('ui/web/table').name,
  require('ui/common/radio').name,
  require('ui/common/asyncSubmit').name,
  require('ui/web/alertDirty').name,
  require('ui/web/notifications').name,
  require('data/model/person').name,
  require('ui/bk/peerReviewStatus').name,
  require('ui/bk/yearEndFinancialDate').name,
  require('ui/bk/clientTaxDetails').name,
  require('ui/bk/clientBillingContract').name,
];

module.exports = angular
  .module('bench.ui.clientDetails', deps)

  .directive('blClientDetails', () => ({
    restrict: 'E',
    scope: {
      clientId: '@',
      showTeamComments: '@',
    },
    bindToController: true,
    template: require('./clientDetails.html'),
    controller: require('./clientDetailsCtrl.js'),
    controllerAs: 'vm',
  }));
